import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const classes = {
  root: css`
    max-block-size: 100%;
  `,

  content: css`
    block-size: 100%;
  `,

  header: css`
    padding: ${spacing(2)};
  `,

  close: css`
    position: absolute;
    inset-inline-end: 0;
    inset-block-start: 0;
  `,
}
